import { Component, Input } from '@angular/core';
import { PatientAttachment } from 'app/core/models/patient-attachment.model';

@Component({
  selector: 'app-patient-attachment-duplicate-link',
  standalone: false,
  templateUrl: './patient-attachment-duplicate-link.component.html',
  styleUrl: './patient-attachment-duplicate-link.component.scss'
})
export class PatientAttachmentDuplicateLinkComponent {
  @Input() patientAttachment: PatientAttachment;
}
